import api from "./api";

export const getContacts = async (params = {}) => {
  try {
    const res = await api.get("/contact/", { params });
    return res.data;
  } catch (error) {
    console.error("Error fetching contacts:", error);
    throw error;
  }
};

export const getContactById = async (id) => {
  try {
    const res = await api.get(`/contact/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching contact:", error);
    throw error;
  }
};

export const createContact = async (data) => {
  try {
    const formattedData = {
      name: data.name,
      email: data.email,
      phone: data.phone || '',
      company: data.company || '',
      message: data.message,
      products: data.products || [],
      status: data.status || 'new',
      createdAt: new Date().toISOString()
    };
    
    console.log("Sending contact data:", formattedData);
    const res = await api.post("/contact/", formattedData);
    return res.data;
  } catch (error) {
    console.error("Error creating contact:", error);
    if (error.response) {
      console.error("Response data:", error.response.data);
      console.error("Response status:", error.response.status);
    }
    throw error;
  }
};

export const updateContactStatus = async (id, status) => {
  try {
    console.log("Updating contact status:", id, status);
    const res = await api.put(`/contact/${id}/status`, `"${status}"`, {
      headers: { "Content-Type": "application/json" }
    });
    return res.data;
  } catch (error) {
    console.error("Error updating contact status:", error);
    if (error.response) {
      console.error("Response data:", error.response.data);
      console.error("Response status:", error.response.status);
    }
    throw error;
  }
};

export const deleteContact = async (id) => {
  try {
    const res = await api.delete(`/contact/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error deleting contact:", error);
    throw error;
  }
};
